import React from 'react';

import { Text } from '@betterment/samba-react';
import { Box, Flex, Heading } from '@betterment/style-closet-react';

// https://github.com/vitejs/vite/issues/19778
import image from '../../images/copilot.png?url';
import { DismissableCard } from '../DismissableCard';

export const FirstImpressionCard: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <DismissableCard cardName="copilot" css={{ p: '0', mb: '9' }}>
      <Flex backgroundColor="bmtGold" width="20%" mr={7} justifyContent="center" alignItems="center">
        <img src={image} alt="reports" height="fit-content" />
      </Flex>
      <Box pt={8} width="70%" pb={5}>
        <Heading variant="secondary">Welcome to your new client command center</Heading>
        <Text color="text.weak">
          Co-pilot aggregates clients you may need to take a look at, all in once place. In some circumstances, you can
          nudge clients who need to complete tasks by sending them email reminders.
        </Text>
      </Box>
    </DismissableCard>
  );
};
